'use client';

import { useTranslations } from 'next-intl';
import { VStack } from '@terra/ui-styled-system';
import { Add01Icon } from '@terra/ui-icons';
import { Button } from '../../../components/button';
import type { DocumentationFileCategory } from './applicationDocumentation.types';
import type { ApplicationDocumentationViewModel } from './applicationDocumentationView.types';
import { ApplicationDocumentationCategoryFiles } from './ApplicationDocumentationCategoryFiles';
import { DocumentationAddMenu } from './DocumentationAddMenu';

type ApplicationDocumentationFocusedSectionProps = {
  section: DocumentationFileCategory;
  viewModel: ApplicationDocumentationViewModel;
};

export const ApplicationDocumentationFocusedSection = ({
  section,
  viewModel,
}: ApplicationDocumentationFocusedSectionProps) => {
  const tCommon = useTranslations('designSystem.common');
  const { isReadOnly, isUploading, onOpenFileDialog, onOpenLinksDialog } =
    viewModel;
  const action =
    section === 'application' ? (
      <DocumentationAddMenu
        triggerVariant="add"
        disabled={isUploading}
        onAddFiles={() => onOpenFileDialog('application')}
        onAddLinks={onOpenLinksDialog}
      />
    ) : (
      <Button
        variant="ghost"
        size="sm"
        fontWeight="normal"
        alignSelf="flex-start"
        disabled={isUploading}
        onClick={() => onOpenFileDialog(section)}
      >
        <Add01Icon size={16} />
        {tCommon('add')}
      </Button>
    );

  return (
    <VStack alignItems="stretch" gap={3} w="full">
      <ApplicationDocumentationCategoryFiles
        category={section}
        viewModel={viewModel}
      />
      {isReadOnly ? null : action}
    </VStack>
  );
};
